import {
  createFilterFormStore,
  usePersistedFilterFormik,
} from "../../../util/usePersistedFilterFormik";
import { convertToFilter, makeObservable } from "../../../util";
import { useEffect } from "react";
import { createSearchResultNavigationStore } from "../../../util/searchResultNavigation";

const reservationFilterStore = makeObservable({});
const reservationNavigationStore = createSearchResultNavigationStore(
  reservationFilterStore,
);

const toReservationFilter = values =>
  convertToFilter({ values, filterKeys: [], skipKeys: ["limit", "offset"] });

const filterFormStore = createFilterFormStore(
  "reservations",
  reservationFilterStore,
  reservationNavigationStore,
  { toFilter: toReservationFilter },
);

const useReservationFilters = () => {
  const formik = usePersistedFilterFormik(
    {
      initialValues: {
        categoryId: "",
        type: { operator: "in" },
      },
    },
    filterFormStore,
  );

  useEffect(() => {
    reservationFilterStore.set(toReservationFilter(formik.values));
  }, [formik.values]);

  return {
    formik,
  };
};

export {
  reservationFilterStore,
  reservationNavigationStore,
  useReservationFilters,
};
